import { toggleCartActionCreator } from 'src/state/cart/action-creators/toggle-cart-action-creator';
import { setPurchasesInCart } from 'src/state/cart/cart-slice';
import { AppDispatch, RootState } from 'src/state/types';

export const addPurchasesToCartActionCreator =
  (amount: number) => (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(setPurchasesInCart(amount));
    toggleCartActionCreator(true)(dispatch, getState);
  };
